import { DashboardPage } from "@/features/dashboard/pages/Dashboard";

const Home = () => {
  return <DashboardPage />;
};

export default Home;
